import React from 'react';
import styled from 'styled-components';
import { HeaderTitle } from '../../../utils/budget-tool-specific';
import FlightsList from './flights-list';

const Flights = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Flights
            </HeaderTitle>
            <FlightsList/>
        </PageContainer>
    )
}

export default Flights;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;